import * as types from '../mutation-types'
import * as apis from '../../apis'
import { setToken } from '../../plugins/axios'
import * as R from 'ramda'
import mTimezone from "moment-timezone";
import moment from "moment";

const state = {
    isLaunch: false,
    logging: true,
    user: {
        name: '',
        gender: '',
    },
    ads: [],
    activities: [],
    activitiesList: [],
    agreements: [],
    addresses: [],
    system: {
        work: false,
        not_work_content: '',
        enable_hour: 9,
        enable_min: 0,
        unable_hour: 23,
        unable_min: 30,
        force_no_touch: false,
        shop_notice_title: '',
        shop_notice_content: '',
        area: [],
    },
    menus: [],
    unreadCount: 0,
    notices: [],
    lineBotId: null,
    isLineMini: false,
    socketState: 'connected',
    driverIds: [],
    blackIds: [],
    messages: [],
    unreadMessages: [],
};

const getters = {
    messages: state => state.messages,
    unreadMessages: state => state.unreadMessages,
    getIsLaunch: state => state.isLaunch,
    logging: state => state.logging,
    user: state => state.user,
    name: state => state.user.name,
    phone: state => state.user.phone,
    ads: state => state.ads,
    activities: state => state.activities,
    activitiesList: state => state.activitiesList,
    agreements: state => state.agreements,
    agreementById: state => id => state.agreements.find(agreement => agreement.id == id),
    addresses: state => state.addresses,
    address: state => state.addresses.find(address => address.is_default),
    addressById: state => id => state.addresses.find(address => address.id == id),
    isWork: state => state.system.work,
    notWorkContent: state => state.system.not_work_content,
    canOrder: state => state.system.can_order,
    enableHour: state => state.system.enable_hour,
    enableMin: state => state.system.enable_min,
    unableHour: state => state.system.unable_hour,
    unableMin: state => state.system.unable_min,
    forceNoTouch: state => state.system.force_no_touch,
    shopNoticeTitle: state => state.system.shop_notice_title,
    shopNoticeContent: state => state.system.shop_notice_content,
    canOrderArea: state => state.system.area,
    menus: state => state.menus,
    unreadCount: state => state.unreadCount,
    notices: state => state.notices,
    isLogin: state => state.user.id || 0,
    lineBotId: state => state.lineBotId,
    isLineMini: state => state.isLineMini,
    socketState: state => state.socketState,
    driverIds: state => state.driverIds,
    blockIds: state => state.blackIds,
};

const actions = {
    getUnreadMessages({ commit }) {
        return apis.getUnreadOrderMessages().then(res => {
            commit(types.SET_UNREAD_MESSAGES, res.data);

            return res.data;
        });
    },
    setMessages({ commit }, messages) {
        commit(types.SET_MESSAGES, messages);
    },
    setIsLaunch({ commit }, val) {
        commit(types.SET_IS_LAUNCH, val);
    },
    login(store, phone) {
        return apis.login(phone).then(res => {
            return res;
        });
    },
    logout({ commit }) {
        apis.logout({
            registration_token: localStorage.getItem('registration_token'),
        }).then(() => {
            commit(types.SET_USER, {name: '', gender: ''});
            localStorage.removeItem('token');
            for (let key in localStorage) {
                if (typeof key === 'string' && key.startsWith('cart-order-')) {
                    localStorage.removeItem(key);
                }
            }

            setToken('');
            if (window.fetchToken && window.fetchToken.postMessage) {
                window.fetchToken.postMessage('setFcmToken');
            }

            if (window.flutter_inappwebview) {
                window.flutter_inappwebview.callHandler('fetchToken', 'setFcmToken');
            }
        });
    },
    verify({ commit }, payload) {
        return apis.verify(payload).then(res => {
            commit(types.LOGGED);
            commit(types.SET_USER, res.data.user);
            setToken(res.data.token);

            return res;
        })
    },
    loginByLine({ commit }, lineId) {
        return apis.loginByLine(lineId).then(res => {
            commit(types.LOGGED);
            commit(types.SET_USER, res.data.user);
            setToken(res.data.token);

            return res;
        })
    },
    verifyPhone({ commit }, payload) {
        return apis.verifyPhone(payload).then(res => {
            commit(types.SET_USER, res.data);

            return res;
        });
    },
    getMe({ commit }) {
        return apis.me().then(res => {
            commit(types.SET_USER, res.data);

            return res;
        });
    },
    getAgreements({ commit }) {
        return apis.getAgreements().then(res => {
            commit(types.SET_AGREEMENTS, res.data);

            return res;
        });
    },
    updateMe({ commit }, payload) {
        return apis.updateMe(payload).then(res => {
            commit(types.SET_USER, res.data);

            return res;
        })
    },
    getAds({ commit }) {
        return apis.Ads().then(res => {
            commit(types.SET_ADS, res.data);
            return res;
        })
    },
    getActivities({ commit }) {
       return apis.getActivities().then(res => {
           let closeActivities = localStorage.getItem('close-activities');
           if (closeActivities) {
               closeActivities = JSON.parse(closeActivities);
           } else {
               closeActivities = [];
           }

           let now = moment();
           closeActivities = closeActivities.filter(function(activity) {
               return moment(activity.date).isAfter(now);
           })
           localStorage.setItem('close-activities', JSON.stringify(closeActivities));

           commit(types.SET_ACTIVITIES, res.data);
           return res;
       });
    },
    closeActivity({ commit }, id) {
       commit(types.CLOSE_ACTIVITY, id);
    },
    getAddresses({ commit }) {
        return apis.getAddresses().then(res => {
            commit(types.SET_ADDRESSES, res.data);

            return res;
        })
    },
    setDefaultAddress({ commit }, addressId) {
        return apis.setDefaultAddress(addressId).then(res => {
            commit(types.SET_DEFAULT_ADDRESS, res.data);

            return res;
        });
    },
    deleteAddress({ commit }, addressId) {
        return apis.deleteAddress(addressId).then(res => {
            commit(types.DELETE_ADDRESS, addressId);

            return res;
        });
    },
    putAddress({ commit }, payload) {
        return apis.putAddress(payload).then(res => {
            commit(types.SET_ADDRESS, res.data);

            return res;
        });
    },
    createAddress({ commit }, payload) {
        return apis.createAddress(payload).then(res => {
            commit(types.SET_ADDRESS, res.data);

            return res;
        })
    },
    setDefaultAgreement({ commit }, id) {
        return apis.setDefaultAgreement(id).then(res => {
            commit(types.SET_DEFAULT_AGREEMENT, res.data);

            return res;
        })
    },
    deleteAgreement({ commit }, id) {
        return apis.deleteAgreement(id).then(res => {
            commit(types.DELETE_AGREEMENT, id);

            return res;
        })
    },
    setDefaultCash({ commit }) {
        return apis.setDefaultCash().then(res => {
            commit(types.SET_DEFAULT_CASH);

            return res;
        })
    },
    getSystemParameter({ commit }) {
        return apis.getSystempParameter().then(res => {
            commit(types.SET_SYSTEMP_PARAMETER, res.data);

            return res;
        });
    },
    setCanOrder({ commit, state }) {
        let timezone = mTimezone().tz('Asia/Taipei');
        let now = moment(timezone);
        let start = now.clone().set('hour', state.system.enable_hour).set('minute', state.system.enable_min).set('second', 0);
        let end = now.clone().set('hour', state.system.unable_hour).set('minute', state.system.unable_min).set('second', 0);

        let canOrder = now.isBetween(start, end) || start.isSame(end);
        if (start.isAfter(end)) {
            canOrder = !now.isBetween(end, start) || start.isSame(end);
        }

        if (state.system.can_order != canOrder) {
            commit(types.SET_CAN_ORDER, canOrder);
        }
    },
    getMenus({ commit }) {
        return apis.getMenus().then(res => {
            commit(types.SET_MENUS, res.data);

            return res;
        });
    },
    getUnreadNoticeCount({ commit }) {
        return apis.getUnreadNoticeCount().then(res => {
            commit(types.SET_UNREAD_COUNT, res.data.count);

            return res;
        });
    },
    getNotices({ commit }) {
        return apis.getNotices().then(res => {
            commit(types.SET_NOTICES, res.data);
            commit(types.SET_UNREAD_COUNT, 0);

            return res;
        });
    },
    setSocketState({ commit }, socketState) {
        commit(types.SET_SOCKET_STATE, socketState);
    },
    getDriverIds({ commit }) {
        return apis.getDriverIds().then(res => {
            commit(types.SET_DRIVER_IDS, res.data);
           return res;
        });
    },
    getBlockIds({ commit }) {
        return apis.getBlockIds().then(res => {
            commit(types.SET_BLOCK_IDS, res.data);
            return res;
        });
    }
};

const mutations = {
    [types.LOGGED](state) {
        state.logging = false;
    },
    [types.SET_USER](state, user) {
        state.user = user;
    },
    [types.SET_ADS](state, ads) {
        state.ads = ads;
    },
    [types.SET_ACTIVITIES](state, activities) {
        state.activities = activities;
        state.activitiesList = R.clone(activities);
    },
    [types.CLOSE_ACTIVITY](state, id) {
        let index = state.activities.findIndex(activity => activity.id == id);
        if (index >= 0) {
            state.activities.splice(index, 1);
        }
    },
    [types.SET_AGREEMENTS](state, agreements) {
        state.agreements = agreements;
    },
    [types.SET_ADDRESSES](state, addresses) {
        state.addresses = addresses;
    },
    [types.SET_DEFAULT_ADDRESS](state, defaultAddress) {
        let oldIndex = state.addresses.findIndex(address => address.is_default);
        if (oldIndex >= 0) {
            let old = R.clone(state.addresses[oldIndex]);
            old.is_default = false;
            state.addresses.splice(oldIndex, 1, old);
        }

        let newIndex = state.addresses.findIndex(address => address.id == defaultAddress.id);
        if (newIndex >= 0) {
            state.addresses.splice(newIndex, 1, defaultAddress);
        } else {
            state.addresses.push(defaultAddress);
        }
    },
    [types.DELETE_ADDRESS](state, id) {
        let index = state.addresses.findIndex(address => address.id == id);
        if (index >= 0) {
            state.addresses.splice(index, 1);
        }
    },
    [types.SET_ADDRESS](state, address) {
        let index = state.addresses.findIndex(val => val.id == address.id);

        if (index >= 0) {
            state.addresses.splice(index, 1, address);
        } else {
            state.addresses.push(address);
        }
    },
    [types.SET_DEFAULT_AGREEMENT](state, agreement) {
        let oldIndex = state.agreements.findIndex(val => val.is_default);
        if (oldIndex >= 0) {
            let old = R.clone(state.agreements[oldIndex]);
            old.is_default = false;
            state.agreements.splice(oldIndex, 1, old);
        }

        let index = state.agreements.findIndex(val => val.id == agreement.id);
        if (index >= 0) {
            state.agreements.splice(index, 1, agreement);
        } else {
            state.agreements.push(agreement);
        }
    },
    [types.DELETE_AGREEMENT](state, id) {
        let index = state.agreements.findIndex(agreement => agreement.id == id);
        if (index >= 0) {
            state.agreements.splice(index, 1);
        }
    },
    [types.SET_DEFAULT_CASH](state) {
        let index = state.agreements.findIndex(agreement => agreement.is_default);

        if (index < 0) {
            return;
        }

        let agreement = state.agreements[index];
        agreement.is_default = false;
        state.agreements.splice(index, 1, agreement);
    },
    [types.SET_SYSTEMP_PARAMETER](state, data) {
        state.system = data;
    },
    [types.SET_CAN_ORDER](state, canOrder) {
        state.system.can_order = canOrder;
    },
    [types.SET_MENUS](state, menus) {
        state.menus = menus;
    },
    [types.SET_IS_LAUNCH](state, val) {
        state.isLaunch = val;
    },
    [types.SET_UNREAD_COUNT](state, count) {
        state.unreadCount = count;
    },
    [types.SET_NOTICES](state, notices) {
        state.notices = notices;
    },
    [types.SET_LINE_BOT_ID](state, id) {
        state.lineBotId = id;
    },
    [types.SET_IS_LINE_MINI](state, isMini) {
        state.isLineMini = isMini;
    },
    [types.SET_SOCKET_STATE](state, socketState) {
        state.socketState = socketState;
    },
    [types.SET_DRIVER_IDS](state, ids) {
        state.driverIds = ids;
    },
    [types.SET_BLOCK_IDS](state, ids) {
        state.blackIds = ids;
    },
    [types.SET_MESSAGES](state, messages) {
        state.messages = messages;
    },
    [types.SET_UNREAD_MESSAGES](state, messages) {
        state.unreadMessages = messages;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
};
